import React from 'react'
import { useFlag } from '@openfeature/react-sdk'

const MemberHeader = () => {
    const { value: songwriterRelease } = useFlag('songwriter-release', false)

    return (
        <>
            <h1>Welcome to {songwriterRelease ? 'The Member Hub' : 'The MLC Portal'}</h1>
        </>
    )
}

export default MemberHeader
